import React, { PropsWithChildren } from 'react'
import Head from 'next/head'
import { Container } from '@moonpig/launchpad-components'
import { useStore } from '@moonpig/web-core-stores'
import { Region } from '@moonpig/web-core-types'
import { useAuthenticationLocaleText } from '../../text-localisation'
import { LoginWizard } from '../LoginWizard'

type LoginPageContainerProps = PropsWithChildren<{
  url: string
  region: Region
  flags?: Record<string, boolean>
}>

export const LoginPageContainer: React.FC<LoginPageContainerProps> = props => {
  const { store, defaultStore } = useStore()

  const isDefaultStore = store.id === defaultStore.id
  const storeName = isDefaultStore ? undefined : store.shortName
  const localeText = useAuthenticationLocaleText()
  const title = localeText('auth_wizard.sign_in.title', storeName)

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="canonical" key="content-head-canonical" href={props.url} />
      </Head>
      <Container limitWidth padding={{ xs: 0, md: 8 }}>
        <LoginWizard flags={props.flags} region={props.region}>
          {props.children}
        </LoginWizard>
      </Container>
    </>
  )
}
